<template>
  <div id="settings-wrapper">
    <v-card
      id="settings"
      class="py-2 pl-2 red--text"
      color="rgba(0, 0, 0, .3)"
      dark
      flat
      link
      min-width="70"
      style="position: fixed; top: 115px; right: -35px; border-radius: 8px;"
    >
      <v-icon
        class="mr-3"
        medium
      >
        mdi-cog
      </v-icon>
    </v-card>

    <v-menu
      v-model="menu"
      :close-on-content-click="false"
      activator="#settings"
      bottom
      content-class="v-settings"
      left
      nudge-left="8"
      offset-x
      origin="top right"
      transition="scale-transition"
    >
      <v-card
        class="text-center mb-0"
        width="300"
      >
        <v-card-text>
          <strong class="mb-3 d-inline-block primary--text">SIDEBAR FILTERS</strong>

          <v-item-group
            v-model="color"
            mandatory
          >
            <v-item
              v-for="color in colors"
              :key="color"
              :value="color"
            >
              <template v-slot="{ active, toggle }">
                <v-avatar
                  :class="active && 'v-settings__item--active'"
                  :color="color"
                  class="v-settings__item"
                  size="25"
                  @click="toggle"
                />
              </template>
            </v-item>
          </v-item-group>

          <v-divider class="my-4 secondary" />

          <v-row
            align="center"
            no-gutters
          >
            <v-col
              cols="auto"
              class="primary--text"
            >
              Dark Mode
            </v-col>

            <v-spacer />

            <v-col cols="auto">
              <v-switch
                v-model="switchTheme"
                class="ma-0 pa-0"
                color="secondary"
                hide-details
              />
            </v-col>
          </v-row>

          <!-- <v-divider class="my-4 secondary" />

          <v-row
            align="center"
            no-gutters
          >
            <v-col cols="auto">
              Sidebar Image
            </v-col>

            <v-spacer />

            <v-col cols="auto">
              <v-switch
                v-model="showImg"
                class="ma-0 pa-0"
                color="secondary"
                hide-details
              />
            </v-col>
          </v-row>

          <v-divider class="my-4 secondary" />

          <strong class="mb-3 d-inline-block">IMAGES</strong>

          <v-item-group
            v-model="image"
            class="d-flex justify-space-between mb-3"
          >
            <v-item
              v-for="image in images"
              :key="image"
              :value="image"
              class="mx-1"
            >
              <template v-slot="{ active, toggle }">
                <v-sheet
                  :class="active && 'v-settings__item--active'"
                  class="d-inline-block v-settings__item"
                  @click="toggle"
                >
                  <v-img
                    :src="image"
                    height="100"
                    width="50"
                  />
                </v-sheet>
              </template>
            </v-item>
          </v-item-group> -->
        </v-card-text>
      </v-card>
    </v-menu>
  </div>
</template>

<script>
  // Mixins
  import Proxyable from 'vuetify/lib/mixins/proxyable'
  import { mapMutations, mapState, mapActions } from 'vuex'

  export default {
    name: 'DashboardCoreSettings',

    mixins: [Proxyable],
    data: () => ({
      color: '#1976D2',
      colors: [
        '#9C27b0',
        '#00CAE3',
        '#4CAF50',
        '#ff9800',
        '#E91E63',
        '#FF5252',
      ],
      switchTheme: false,
      image: require('./../../../../extraResources/images/sidebar/sidebar-4.jpg'),
      images: [
        require('./../../../../extraResources/images/sidebar/sidebar-1.jpg'),
        require('./../../../../extraResources/images/sidebar/sidebar-2.jpg'),
        require('./../../../../extraResources/images/sidebar/sidebar-3.jpg'),
        require('./../../../../extraResources/images/sidebar/sidebar-4.jpg'),
      // 'https://demos.creative-tim.com/material-dashboard/assets/img/sidebar-1.jpg',
      // 'https://demos.creative-tim.com/material-dashboard/assets/img/sidebar-2.jpg',
      // 'https://demos.creative-tim.com/material-dashboard/assets/img/sidebar-3.jpg',
      // 'https://demos.creative-tim.com/material-dashboard/assets/img/sidebar-4.jpg',
      ],
      menu: false,
      saveImage: 'local-resource://src/images/sidebar/sidebar-1.jpg',
      showImg: true,
    }),
    created: function () {
      // console.log(__dirname)
      (function (self) {
        let counter = 0
        return setInterval(function () {
          if (counter > 3) counter = 0
          self.image = self.images[counter++]
        }, 1000 * 120)
      })(this)
    },
    mounted () {
      this.color = this.themeColor
      this.switchTheme = this.darkMode
    },

    computed: {
      ...mapState({
        barImage: state => state.barImage,
        darkMode: state => state.settings.darkMode,
        themeColor: state => state.settings.themeColor,
      }),
      theColor () {
        return this.themeColor
      },
    },

    watch: {
      switchTheme (val) {
        this.$vuetify.theme.dark = val
        this.setDarkMode(val)
      },
      color (val) {
        if (!val) val = '#1976D2'
        this.setBarColor(val)
        this.setThemeColor(val)
        this.$vuetify.theme.themes.light.primary = val
        this.$vuetify.theme.themes.dark.primary = val
      },

      showImg (val) {
        if (!val) {
          this.saveImage = this.barImage
          this.setBarImage('')
        } else if (this.saveImage) {
          this.setBarImage(this.saveImage)
          this.saveImage = ''
        } else {
          this.setBarImage(val)
        }
      },
      image (val) {
        this.setBarImage(val)
      },
      active (val) {
      },
    },
    methods: {
      ...mapMutations({
        setBarImage: 'SET_BAR_IMAGE',
      }),
      ...mapActions({
        setBarColor: 'setBarColor',
        setDarkMode: 'settings/setDarkMode',
        setThemeColor: 'settings/setThemeColor',
      }),
    },
  }
</script>

<style lang="sass">
  .v-settings
    .v-item-group > *
      cursor: pointer

    &__item
      border-width: 3px
      border-style: solid
      border-color: transparent !important

      &--active
        border-color: #CCCCCC !important
</style>
